import type { MediaThumbnailProps } from '@frameio/vapor';

const UNSUPPORTED_DISPLAY_CATEGORY = 'unsupported';

/**
 * Determines the display category for the `MediaThumbnail` component
 * based on the asset's file type, or returns 'unsupported'.
 *
 * @param fileType The asset's file type.
 * @returns The display category or 'unsupported' if the file type is invalid.
 */
export const getAssetDisplayCategory = (
  fileType: string | undefined | null
): MediaThumbnailProps['displayCategory'] => {
  return fileType
    ? (fileType.toLowerCase() as MediaThumbnailProps['displayCategory'])
    : UNSUPPORTED_DISPLAY_CATEGORY;
};
